export default "__VITE_ASSET__9af31bf7__"